const transitions = {
  OPEN: ['IN_PROGRESS'],
  IN_PROGRESS: ['WAITING_USER', 'RESOLVED'],
  WAITING_USER: ['IN_PROGRESS', 'RESOLVED'],
  RESOLVED: ['CLOSED'],
  CLOSED: [],
};

export const allowedTicketStatuses = (status) => [status, ...(transitions[status] || [])];
